<div style="max-width: 48px; max-height: 48px">
  <bb-card-vendor-ui vendor="mastercard"></bb-card-vendor-ui>
</div>
